class Query {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.subject = data ? data.subject : ''
    this.email = data ? data.email : ''
    this.location = data ? data.location : ''
    this.message = data ? data.message : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default Query



// WEBPACK FOOTER //
// ./src/models/Query.js